<template>
    <div>
        <div class="modal-container">
            <div class="modal-header">
                {{action}} Subscription
                <div class="delete is-large is-pulled-right" @click="doClose"></div>
            </div>

            <div class="modal-body">
                <form>
                    <div class="is-size-3 left10">
                        {{id}}
                    </div>

                    <div class="top20 left10" v-if="this.toDo == 'renew'">
                        This subscription's renewal has been added to your cart. Once you complete the checkout process, the subscription period will be extended and your slinks and subslinks will be re-activated.
                    </div>
                    <div class="top20 left10" v-if="this.toDo == 'cancel'">
                        This subscription will be removed from your automatic renewals. It will not be billed again on its renewal date. It will, however, remain active until that date.
                    </div>
                     <div class="top20 left10" v-if="this.toDo == 'reinstate'">
                        This subscription  will be reinstated.  It will be billed and extended on its next renewal date.
                    </div>

                    <div class="top20 left10">
                        <button  class="button is-warning" type="submit" @click.prevent="save">{{action.toUpperCase()}}</button>
                        <button class="button left10"  @click.prevent="doClose">CANCEL</button>
                    </div>
                </form>
            </div>

            <div class="modal-footer">
                <div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
  props: {id: String, callBack: Function, toDo: String},
  data: function() {
    return {
      
    };
  },
  computed:{
      action: function(){
          if(this.toDo == 'renew'){
              return 'Renew';
          } else if(this.toDo == 'cancel'){
              return 'Remove';
          } else if(this.toDo == 'reinstate'){
              return 'Reinstate';
          } 
      }
  },
  mounted: function() {
    
  },
  methods: {
    save: function(){

        //TODO validate url structure and provide default http=:// if necessary

        this.callBack(this.newUrl, this.newName);
        this.doClose();
    },
    doClose: function() {
        this.$emit("close");
    }
  }
};
</script>

<style scoped>
    .modal-container {
        max-width: 600px;
        min-height: 330px;
    }
</style>



// WEBPACK FOOTER //
// src/components/ModalAddRemSubscr.vue